/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/field/errormessage/errormessage_styles';



/* ========== ~~~~~~~~~~ EXPORT : FORM : FIELD : ERROR MESSAGE ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) =>
	<div className={`errormessage ${props.classes.errormessage}`}>
    	{props.children}
    </div>
);
